export default __webpack_public_path__ + "static/img_4-dcb587271882b46e19eafc5dba859393.png";